import React from "react";
const TmsAccInnerPagesDisableDates = () => {
  return <div>Coming Soon - Disable Dates</div>;
};
export default TmsAccInnerPagesDisableDates;
